import { FC } from 'react'
import { LayoutAnimation, Platform, TouchableHighlight, UIManager, View, ViewStyle } from 'react-native'
import { Colors } from '../../util/util'

interface ToggleProps {
  onChange: (val: boolean) => void
  toggleValue?: boolean
  disabled?: boolean
  height?: number
  width?: number
  radius?: number
}

if (Platform.OS === 'android') {
  UIManager.setLayoutAnimationEnabledExperimental(true)
}
const container = {
  width: 44,
  borderRadius: 25,
  height: 25,
  flexDirection: 'row',
  alignItems: 'center',
  borderWidth: 1.2,
  paddingLeft: 3,
  paddingRight: 3,
  borderColor: '#595959',
  backgroundColor: Colors.WHITE,
}

const styles = {
  circle: {
    backgroundColor: '#595959',
  } as ViewStyle,
  container: {
    marginRight: 12,
    height: 25,
    backgroundColor: Colors.WHITE,
  },
  on: {
    circle: {
      backgroundColor: '#fff',
    } as ViewStyle,
    container: {
      ...container,
      backgroundColor: Colors.PRIMARY,
      justifyContent: 'flex-end',
      borderColor: Colors.PRIMARY,
    } as ViewStyle,
  },
  off: {
    circle: {
      backgroundColor: '#595959',
      borderColor: '#595959',
    } as ViewStyle,
    container: {
      ...container,
      backgroundColor: Colors.WHITE,
    } as ViewStyle,
  },
}

const Toggle: FC<ToggleProps> = ({
  onChange,
  toggleValue = false,
  disabled = false,
  height = 25,
  width = 44,
  radius = 8,
}: ToggleProps) => {
  // const [localValue, setLocalValue] = useState(toggleValue)
  const value = toggleValue //|| localValue
  const cStyle = value ? styles.on : styles.off
  const handleChange = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)
    if (!disabled) {
      onChange(!value)
    }
    // if (toggleValue) {
    //   setLocalValue(!value)
    // }
  }

  const underlayColor = Colors.TRANSPARENT
  return (
    <TouchableHighlight
      style={[styles.container, cStyle.container, { height: height, width: width }]}
      underlayColor={underlayColor}
      onPress={handleChange}
      testID="toggle-notification">
      <View style={[styles.circle, cStyle.circle, { width: radius * 2, height: radius * 2, borderRadius: radius }]} />
    </TouchableHighlight>
  )
}

export default Toggle
